import { useEffect } from 'react';
import { useUserStore } from '@/stores/user/userStore';
import useWelcomeBackModalStore from '@/stores/welcomeBackModal/welcomeBackModalStore';
import { shouldShowCampaignModal } from '@/utils/campaignUtils';

/**
 * Hook to manage the Welcome Back Campaign Modal
 * This hook should be used in components that are rendered after login
 * to check if the modal should be shown
 */
const useWelcomeBackModal = () => {
  const user = useUserStore((state) => state.user);
  const auth = useUserStore((state) => state.auth);
  const clearJustLoggedIn = useUserStore((state) => state.clearJustLoggedIn);
  const { checkModalStatus, showCampaignModal, reset } = useWelcomeBackModalStore();

  useEffect(() => {
    // Only check modal status if user just logged in (not on page refresh)
    if (user && auth?.access_token && auth?.just_logged_in) {
      // Check for campaign modal first
      if (shouldShowCampaignModal()) {
        // Show campaign modal with a delay
        setTimeout(() => {
          showCampaignModal();
        }, 500);
      } else {
        checkModalStatus();
      }
      // Clear the just_logged_in flag after checking
      clearJustLoggedIn();
    }

    // Reset modal state when user logs out
    if (!user || !auth?.access_token) {
      reset();
    }
  }, [user, auth?.access_token, auth?.just_logged_in, checkModalStatus, showCampaignModal, reset, clearJustLoggedIn]);

  // Return the modal store for components that need direct access
  return useWelcomeBackModalStore();
};

export default useWelcomeBackModal;
